import _ from 'lodash'

export const convertMetersToInches = (v: number | string, precision?: number): number => {
  return precision ? _.round(_.toNumber(v) * 39.3701, precision) : _.toNumber(v) * 39.3701
}

export const convertInchesToMeters = (v: number | string, precision?: number): number => {
  return precision ? _.round(_.toNumber(v) / 39.3701, precision) : _.toNumber(v) / 39.3701
}
